import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import Page from 'components/Page/Dashboard';
import BackButton from 'components/Buttons/BackButton';
import OutlineButton from 'components/Buttons/OutlineButton';
import InputBox from 'components/Form/InputBox';

import { useKycDocInfo } from 'hooks/redux/kyc';
import CommonStyle from 'styles/common';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    padding: '0 15px',
  },
  topic: {
    font: '12px SofiaPro-SemiBold',
    color: palette.colorBtnTxt,
    textTransform: 'capitalize',
  },
  title: {
    font: '30px SofiaPro-Bold',
    lineHeight: '30px',
    marginBottom: '10px',
    color: palette.secondaryColor,
  },
  content: {
    textAlign: 'center',
    color: '#AEAEAE',
    font: '15px SofiaPro',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between',
  },
  error: {
    color: 'red',
    textAlign: 'center',
  },
}));

const DocumentationState = ({ history }) => {
  const classes = useStyles();
  const commonClasses = CommonStyle();
  const doc = useKycDocInfo();
  const isResolve = history.location.state === 'resolve';
  return (
    <Page>
      <Box className={classes.root} display="flex" flexDirection="column" flex={1}>
        <Box className={commonClasses.line2} mb={2} />
        <Box>
          <BackButton color={commonClasses.backBtn} page={isResolve ? '/kyc/resolve' : '/kyc/documentation/country'} />
        </Box>
        <Box textAlign="center" mt={3} mb={1}>
          <Typography component="h3" className={classes.topic}>
            KYC/AML VERIFICATION FORM
          </Typography>
        </Box>
        <Box textAlign="center" mb={6}>
          <Typography component="h3" className={classes.title}>
            Issuing State of Documentation
          </Typography>
          <span className={classes.content}>
            Select the State in which your verification documents are issued from.
          </span>
        </Box>
        <Formik
          initialValues={{
            state: doc.state.name,
          }}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(true);
            const route = isResolve ? '/kyc/resolve' : '/kyc/documentation/tax';
            history.push(route);
          }}
          validationSchema={Yup.object().shape({
            state: Yup.string()
              .required('Required'),
          })}
        >
          {({
            errors,
            touched,
            values,
            isSubmitting,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.form}>
              <Box>
                <InputBox
                  label="Select a State"
                  name="state"
                  onClick={() => history.push('/kyc/documentation/select-state')}
                  value={values.state}
                  format="outline"
                />
                {
                  errors.state && touched.state
                    ? (
                      <Typography className={classes.error}>
                        {errors.state}
                      </Typography>
                    ) : null
                }
              </Box>
              <Box display="flex" className={commonClasses.continue}>
                <OutlineButton type="submit" disabled={isSubmitting}>
                  {isResolve ? 'Done' : 'Next'}
                </OutlineButton>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Page>
  );
};

DocumentationState.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(DocumentationState);
